/* eslint-disable */
// frontend/src/pages/ConditionManage.js
import React, { useEffect, useState } from "react";
import { getPhotoStorage, setPhotoStorage } from "../api/propertyApi";

// ============================================================
// 사진 및 미디어 설정 (관리탭 카드 안쪽)
//
// [CM_LAYOUT_V2] 레이아웃 재구성
//   기존 문제: className="grid-2" / "flex gap-2" 등을 쓰고 있었으나
//              해당 CSS 가 프로젝트에 존재하지 않아(Tailwind 미설치)
//              전부 무시되어 라벨과 입력칸이 어긋나 보였다.
//   해결: CSS 클래스에 의존하지 않고 인라인 스타일로 직접 배치.
//         SliderConfigManager 카드와 동일한 회색 박스 스타일로 통일.
//
// 연관: App.js 관리탭에서 <ConditionManage /> 로 사용
//       저장은 PUT /api/config (모든 항목을 한 번에 저장)
// ============================================================

const CONFIG_KEY = "app_config_v1";

// 조건 항목 노출 기본값 (App.js 532줄에서 localStorage 'filter_visibility' 를 읽어 사용)
const DEFAULT_VIS = {
  room_cnt: true, bath_cnt: true, fee_year: true, fee_month: true, floor: true,
  owner_household: true, owner_room: false, owner_bath: false,
  sale_type_sub_rent: true, sale_type_sub_living: true,
  living_condition_ev: false, internal_condition_interior: false,
  internal_condition_water: false, internal_condition_city_gas: false,
  bath_division: false,
};

const ITEMS = [
  ["room_cnt", "룸수"], ["bath_cnt", "욕실수"], ["fee_year", "보증금"],
  ["fee_month", "월세"], ["floor", "해당층"], ["owner_household", "주인세대"],
  ["owner_room", "주인세대 룸수"], ["owner_bath", "주인세대 욕실수"],
  ["sale_type_sub_rent", "임대승계 매매"], ["sale_type_sub_living", "입주가능 매매"],
  ["living_condition_ev", "승강기"], ["internal_condition_interior", "인테리어"],
  ["internal_condition_water", "수도시설"], ["internal_condition_city_gas", "도시가스"],
  ["bath_division", "화장실 남녀구분"],
];

const api = (p, opt) => fetch(p, opt).then(r => r.json());

// ── 공통 스타일 (CSS 파일 없이 여기서 직접 정의) ───────────
const boxStyle = {
  padding: "14px", background: "#f8fafc",
  border: "1px solid #e2e8f0", borderRadius: "8px", marginBottom: "12px",
};
const boxTitleStyle = {
  fontSize: "14px", fontWeight: 700, color: "#1e293b", margin: "0 0 3px 0",
};
const boxDescStyle = {
  fontSize: "11px", color: "#94a3b8", margin: "0 0 10px 0",
};
// 화면 폭에 따라 1~2열로 자동 조정된다 (minmax 로 최소 폭 보장)
const gridStyle = {
  display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))", gap: "10px",
};
const labelStyle = {
  fontSize: "12px", color: "#64748b", display: "block", marginBottom: "4px",
};
const inputStyle = {
  width: "100%", height: "32px", padding: "0 8px",
  border: "1px solid #cbd5e1", borderRadius: "5px",
  fontSize: "13px", boxSizing: "border-box", background: "#fff",
};
const saveBtnStyle = {
  padding: "9px 22px", background: "#2563eb", color: "#fff",
  border: "none", borderRadius: "6px", fontSize: "14px",
  fontWeight: 600, cursor: "pointer",
};
// 라디오 대신 쓰는 버튼형 선택 (App.js 의 modernRadioStyle 과 같은 느낌)
const pillStyle = (active) => ({
  padding: "7px 16px", borderRadius: "6px", fontSize: "13px", cursor: "pointer",
  border: active ? "1px solid #2563eb" : "1px solid #cbd5e1",
  background: active ? "#2563eb" : "#fff",
  color: active ? "#fff" : "#475569",
  fontWeight: active ? 600 : 400,
});

/** 라벨 + 입력칸 한 벌 (라벨이 위, 입력칸이 아래) */
function Field({ label, children }) {
  return (
    <div style={{ minWidth: 0 }}>
      <label style={labelStyle}>{label}</label>
      {children}
    </div>
  );
}

export default function ConditionManage({ values, onToggle, onSearch, onReset }) {
  // 새 사진을 '어디에 올릴지' — 서버에 저장되는 전체 설정
  const [photoStorage, setPhotoStorageState] = React.useState("server");
  const [cfg, setCfg] = React.useState(() => {
    try { return JSON.parse(localStorage.getItem(CONFIG_KEY)) || {}; }
    catch { return {}; }
  });

  React.useEffect(() => {
    getPhotoStorage().then(d => d?.ok && setPhotoStorageState(d.storage));
  }, []);

  const [form, setForm] = useState({
    supplier_office: "", supplier_phone: "",
    supplier_manager: "", supplier_manager_mobile: "",
    watermark_url: "", watermark_opacity: "0.08",
    PHOTO_THUMB_DIR: "uploads/thumbs",
    PHOTO_THUMB_URL_BASE: "/static/thumbs",
    DRIVE_PARENT_ID: "", DRIVE_SUPPORTS_ALL_DRIVES: "true",
  });

  const [visibility, setVisibility] = useState(() => {
    const v = localStorage.getItem("filter_visibility");
    return v ? { ...DEFAULT_VIS, ...JSON.parse(v) } : { ...DEFAULT_VIS };
  });

  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    api("/api/config")
      .then(c => {
        setForm(f => ({ ...f, ...c }));
        localStorage.setItem("supplier_cfg", JSON.stringify({ ...form, ...c }));
      })
      .catch(() => {
        const cached = localStorage.getItem("supplier_cfg");
        if (cached) setForm(JSON.parse(cached));
      });
  }, []);

  const onFormChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const onUploadWatermark = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const res = await fetch("/api/uploads/watermark", { method: "POST", body: fd });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      const url = data.url || data.path || (data.filename ? `/uploads/${data.filename}` : "");
      if (!url) throw new Error("업로드 응답에 url 없음");
      const next = { ...form, watermark_url: url };
      setForm(next);
      localStorage.setItem("supplier_cfg", JSON.stringify(next));
      setMsg("워터마크 이미지를 올렸습니다. 아래 '설정 저장'을 눌러 마무리하세요.");
    } catch (e) {
      setMsg(`업로드 실패: ${e.message}`);
    }
  };

  // [CM_LAYOUT_V2] 저장 버튼 통합.
  // 기존에는 섹션마다 저장 버튼이 있었으나 셋 다 같은 onSave 를 호출해
  // 결국 전체를 저장하는 동일 동작이었다. 혼동을 없애기 위해 하나로 합쳤다.
  const onSave = async () => {
    setSaving(true); setMsg("저장 중...");
    try {
      await fetch("/api/config", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      }).then(r => r.json());
      localStorage.setItem("supplier_cfg", JSON.stringify(form));
      localStorage.setItem("filter_visibility", JSON.stringify(visibility));
      setMsg("저장했습니다.");
    } catch (e) {
      setMsg(`저장 실패: ${e.message}`);
    } finally {
      setSaving(false);
    }
  };

  const toggleVis = (key, checked) => setVisibility(v => ({ ...v, [key]: checked }));

  return (
    <div style={{ marginTop: "14px" }}>

      {/* ── 사진 저장 위치 (서버 전체 설정) ───────────────── */}
      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>사진 저장 위치</h4>
        <p style={boxDescStyle}>
          앞으로 올리는 사진이 실제로 보관될 곳입니다. 서버 전체에 적용됩니다.
        </p>
        <div style={{ display: "flex", gap: "8px" }}>
          {[["server", "자체 서버"], ["gdrive", "구글 드라이브"]].map(([v, label]) => (
            <button
              key={v} type="button" style={pillStyle(photoStorage === v)}
              onClick={async () => { setPhotoStorageState(v); await setPhotoStorage(v); }}
            >{label}</button>
          ))}
        </div>
      </div>

      {/* ── 공급자 정보 ─────────────────────────────────── */}
      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>공급자 정보</h4>
        <p style={boxDescStyle}>매물 인쇄물과 문자에 표시되는 사무소 연락처입니다.</p>
        <div style={gridStyle}>
          <Field label="사무실명">
            <input style={inputStyle} name="supplier_office" value={form.supplier_office} onChange={onFormChange} />
          </Field>
          <Field label="대표번호">
            <input style={inputStyle} name="supplier_phone" value={form.supplier_phone} onChange={onFormChange} />
          </Field>
          <Field label="담당자">
            <input style={inputStyle} name="supplier_manager" value={form.supplier_manager} onChange={onFormChange} />
          </Field>
          <Field label="담당자 휴대폰">
            <input style={inputStyle} name="supplier_manager_mobile" value={form.supplier_manager_mobile} onChange={onFormChange} />
          </Field>
        </div>
      </div>

      {/* ── 사진 저장 설정 ──────────────────────────────── */}
      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>사진 저장 설정</h4>
        <p style={boxDescStyle}>썸네일 경로와 구글 드라이브 연결 정보입니다. 평소에는 바꿀 일이 없습니다.</p>
        <div style={gridStyle}>
          <Field label="썸네일 디렉터리">
            <input style={inputStyle} name="PHOTO_THUMB_DIR" value={form.PHOTO_THUMB_DIR} onChange={onFormChange} />
          </Field>
          <Field label="썸네일 URL 베이스">
            <input style={inputStyle} name="PHOTO_THUMB_URL_BASE" value={form.PHOTO_THUMB_URL_BASE} onChange={onFormChange} />
          </Field>
          <Field label="구글드라이브 폴더 ID">
            <input style={inputStyle} name="DRIVE_PARENT_ID" value={form.DRIVE_PARENT_ID} onChange={onFormChange} placeholder="공유드라이브 폴더 ID" />
          </Field>
          <Field label="공유드라이브 지원(supportsAllDrives)">
            <select style={inputStyle} name="DRIVE_SUPPORTS_ALL_DRIVES" value={form.DRIVE_SUPPORTS_ALL_DRIVES} onChange={onFormChange}>
              <option value="true">사용함 (true)</option>
              <option value="false">사용 안 함 (false)</option>
            </select>
          </Field>
        </div>
      </div>

      {/* ── 워터마크 ───────────────────────────────────── */}
      <div style={boxStyle}>
        <h4 style={boxTitleStyle}>워터마크</h4>
        <p style={boxDescStyle}>사진 위에 겹쳐 표시할 이미지입니다. 권장 불투명도 0.05~0.12.</p>
        <div style={gridStyle}>
          <Field label="이미지 업로드">
            <input type="file" accept="image/*" style={{ ...inputStyle, paddingTop: "5px" }}
                   onChange={(e) => onUploadWatermark(e.target.files?.[0])} />
          </Field>
          <Field label="이미지 URL (업로드 시 자동입력)">
            <input style={inputStyle} name="watermark_url" value={form.watermark_url} onChange={onFormChange}
                   placeholder="/uploads/xxx.png 또는 https://…" />
          </Field>
          <Field label="불투명도 (0~1)">
            <input style={inputStyle} name="watermark_opacity" value={form.watermark_opacity}
                   onChange={onFormChange} inputMode="decimal" />
          </Field>
        </div>
        {form.watermark_url && (
          <div style={{ marginTop: "10px" }}>
            <div style={{ ...labelStyle, marginBottom: "5px" }}>미리보기</div>
            <img src={form.watermark_url} alt="워터마크 미리보기"
                 style={{ maxHeight: "70px", maxWidth: "100%",
                          opacity: Number(form.watermark_opacity) || 0.1,
                          border: "1px solid #e2e8f0", borderRadius: "5px",
                          background: "#fff", padding: "5px" }} />
          </div>
        )}
      </div>

      {/* ── 저장 (위 네 박스를 한 번에 저장) ──────────────── */}
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <button onClick={onSave} disabled={saving} style={saveBtnStyle}>
          {saving ? "저장 중..." : "설정 저장"}
        </button>
        {msg && <span style={{ fontSize: "13px", color: "#475569" }}>{msg}</span>}
      </div>

      {/* 조건 항목 노출 관리 — 현재 비활성.
          ※ localStorage 의 'filter_visibility' 값은 App.js 532줄에서 실제로 읽고 있다.
             즉 값 자체는 살아 있고, 편집 화면만 꺼둔 상태다. */}
      {/* <div style={boxStyle}>
        <h4 style={boxTitleStyle}>조건 항목 노출 관리</h4>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "6px" }}>
          {ITEMS.map(([key, label]) => (
            <label key={key} style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px" }}>
              <input type="checkbox" checked={!!visibility[key]}
                     onChange={(e) => toggleVis(key, e.target.checked)} />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </div> */}
    </div>
  );
}